import { render, staticRenderFns } from "./MobileDesktopBanner.vue?vue&type=template&id=949eceb6&scoped=true"
import script from "./MobileDesktopBanner.vue?vue&type=script&lang=js"
export * from "./MobileDesktopBanner.vue?vue&type=script&lang=js"
import style0 from "./MobileDesktopBanner.vue?vue&type=style&index=0&id=949eceb6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "949eceb6",
  null
  
)

export default component.exports